
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :stroke="color" fill="none" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"
    >
      <mask id="mask0_2181_64" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="1" y="16" width="3" height="5"><rect x="1.94092" y="16.4557" width="1.77103" height="4.13241"></rect></mask><g mask="url(#mask0_2181_64)"><path d="M3.41678 20.5881V16.7509L1.64575 17.9316"></path></g><mask id="mask1_2181_64" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="7" y="13" width="5" height="8"><path d="M7.29285 13.441H11.3006V20.5881H7.29285V13.441Z"></path></mask><g mask="url(#mask1_2181_64)"><path d="M11.3006 20.1873C11.3006 20.1873 8.89494 20.1873 7.6936 20.1873C8.49516 17.3819 10.8978 17.7827 10.8978 15.7674C10.8973 14.8883 10.181 14.1757 9.29672 14.1757C8.41245 14.1757 7.69561 14.8883 7.69561 15.7674"></path></g><mask id="mask2_2181_64" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="13" y="8" width="10" height="13"><path d="M13.7197 8.58057H21.7248V11.916L22.059 13.2502V20.5882H13.7197V8.58057Z"></path></mask><g mask="url(#mask2_2181_64)"><path d="M14.4181 16.5856C14.4181 18.4147 15.883 19.9211 17.7228 19.9211C19.5626 19.9211 21.089 18.4383 21.089 16.6093C21.089 14.7802 19.5626 13.2502 17.7228 13.2502L21.0582 9.24762H15.0544"></path></g><path d="M2.19702 13.7494C2.19702 13.7494 6.1914 12.7723 10.725 10.1464C15.9189 7.13805 17.9087 3.41174 17.9087 3.41174M17.9087 3.41174L18.2978 5.38928M17.9087 3.41174L15.8204 3.85992"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiSelfIncreasingValue",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
